module.exports = __webpack_public_path__ + "img/minus.a9c93c2e.svg";